/**
 * Utilitaires pour les plans d'abonnement
 * Centralise la logique des plans pour éviter la duplication
 */

// Plans d'abonnement disponibles - IDs
export const SUBSCRIPTION_PLANS = {
  BASIC: 'basic',
  PREMIUM: 'premium',
  QUARTERLY: 'quarterly',
  ANNUAL: 'annual'
};

/**
 * Obtient les détails d'un plan d'abonnement
 * Utilise la même logique que SubscriptionManagement.jsx
 * @param {string} plan - ID du plan
 * @returns {Object} - Détails du plan
 */
export const getPlanDetails = (plan) => {
  const plans = {
    basic: {
      name: "Basique",
      price: "0",
      priceNumeric: 0,
      currency: "XOF",
      features: ["Accès limité", "Fonctionnalités de base", "Support par email"]
    },
    premium: {
      name: "Mensuel",
      price: "5,433",
      priceNumeric: 5433,
      currency: "XOF",
      features: ["Accès complet", "Toutes les fonctionnalités", "Support prioritaire", "Mises à jour exclusives"]
    },
    quarterly: {
      name: "Trimestriel",
      price: "21,733",
      priceNumeric: 21733,
      currency: "XOF",
      features: ["Accès complet", "Toutes les fonctionnalités", "Support prioritaire", "Mises à jour exclusives", "Même prix proratisé"]
    },
    annual: {
      name: "Annuel",
      price: "65,200",
      priceNumeric: 65200,
      currency: "XOF",
      features: ["Accès complet", "Toutes les fonctionnalités", "Support prioritaire", "Mises à jour exclusives", "Prix de base annuel"]
    }
  };

  return plans[plan] || plans.basic;
};

/**
 * Formate le prix d'un plan
 * @param {string} planId - ID du plan
 * @returns {string} - Prix formaté
 */
export const formatPlanPrice = (planId) => {
  const plan = getPlanDetails(planId);
  if (plan.priceNumeric === 0) {
    return "Gratuit";
  }
  return `${plan.price} ${plan.currency}`;
};

/**
 * Obtient la couleur du badge pour un plan
 * @param {string} planId - ID du plan  
 * @returns {string} - Couleur du badge
 */
export const getPlanBadgeColor = (planId) => {
  const colors = {
    basic: '#6c757d',
    premium: '#28a745',
    quarterly: 'var(--app-primary-color)',
    annual: '#ffc107'
  };
  return colors[planId] || colors.basic;
};

/**
 * Obtient tous les plans disponibles
 * @returns {Array} - Liste des plans avec leurs détails
 */
export const getAllPlans = () => {
  return Object.values(SUBSCRIPTION_PLANS).map(planId => ({
    id: planId,
    ...getPlanDetails(planId)
  }));
};

/**
 * Calcule la durée d'un abonnement en jours
 * @param {string} planId - ID du plan
 * @returns {number|null} - Nombre de jours ou null pour plan gratuit
 */
export const getPlanDuration = (planId) => {
  const durations = {
    basic: null,
    premium: 30,
    quarterly: 90,
    annual: 365
  };
  return durations[planId] || null;
};

/**
 * Vérifie si un plan est payant
 * @param {string} planId - ID du plan
 * @returns {boolean} - True si le plan est payant
 */
export const isPaidPlan = (planId) => {
  const plan = getPlanDetails(planId);
  return plan.priceNumeric > 0;
};